import dynamic from 'next/dynamic';

export enum RichTextEntries {
  Button = 'Button',
  LeadGenBanner = 'LeadGenBanner',
}

export enum ContentTypeName {
  LeadGenBanner = 'LeadGenBanner',
  SeoSection = 'SeoSection',
  Wrapper = 'Wrapper',
  PageOverviewBanner = 'PageOverviewBanner',
}

export enum ContentTypeIds {
  Asset = 'Asset',
  button = 'button',
  contentItem = 'contentItem',
  footer = 'footer',
  header = 'header',
  leadGenBanner = 'leadGenBanner',
  notificationTranslation = 'notificationTranslation',
  onboardingPopup = 'onboardingPopup',
  pmtPage = 'pmtPage',
  seo = 'seo',
  seoSection = 'seoSection',
  mainTranslation = 'mainTranslation',
  trackingTranslation = 'trackingTranslation',
  landingPage = 'landingPage',
  wrapper = 'wrapper',
  pageOverviewBanner = 'pageOverviewBanner',
  pmtOnboardingPopup = 'pmtOnboardingPopup',
  blogPost = 'blogPost',
}

export const entryPages: ContentTypeIds[] = [
  ContentTypeIds.landingPage,
  ContentTypeIds.pmtPage,
  ContentTypeIds.blogPost,
];

export const ContentTypeRichText: {
  [key: string]: string;
} = {
  [ContentTypeIds.landingPage]: 'content',
  [ContentTypeIds.wrapper]: 'content',
};

export const ContentTypeMapping: {
  [key in ContentTypeName]?: React.ComponentType<any>;
} = {
  [ContentTypeName.LeadGenBanner]: dynamic(async () => import('../components/LeadGenBanner')),
  [ContentTypeName.SeoSection]: dynamic(async () => import('../components/SEOSection')),
  [ContentTypeName.Wrapper]: dynamic(async () => import('../components/Wrapper')),
  [ContentTypeName.PageOverviewBanner]: dynamic(async () => import('../components/PageOverviewBanner')),
};
